import * as React from "react";
const SVGComponent = ({ color = "black", height = "10px", width = "17px", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6785 8.1648V6.95919H15.1306C15.6175 6.95919 16.0348 6.54176 16.0348 6.05495L16.0347 3.94524C16.0347 3.45843 15.6174 3.041 15.1305 3.041H14.6784V1.83539C14.6784 1.3488 14.2611 0.931152 13.7741 0.931152L1.71833 0.931257C1.23142 0.931257 0.964844 1.38244 0.964844 1.86922V8.13097C0.964844 8.61778 1.23142 9.06885 1.71833 9.06885H13.7741C14.2611 9.06885 14.6785 8.65171 14.6785 8.1648ZM2.17058 8.1648C2.12643 8.1648 2.01984 8.05842 2.01984 8.01406V2.13685C2.01984 2.0927 2.12643 1.98611 2.17058 1.98611H13.4729C13.4729 1.98611 13.6236 2.0927 13.6236 2.13685V8.01406C13.6236 8.05831 13.5173 8.1648 13.4729 8.1648H2.17058Z"
      fill="black"
    />
    <path
      d="M7.52324 2.28769V4.8021L3.37598 3.62543L8.87351 7.71289V5.19848L13.0208 6.37515L7.52324 2.28769Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;